import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearchComment({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7" y="9" width="10" height="1" rx=".5" fill={fill}/>
            <rect x="7" y="12" width="10" height="1" rx=".5" fill={fill}/>
            <path stroke={fill} d="M16 16.5h-.207l-.147.146L14 18.293l-1.646-1.647-.147-.146H5a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-3z"/>
        </svg>
    );
}

export default IconSearchComment;
